<app-navbar-style-two></app-navbar-style-two>

<div class="privacy-policy-section">
  <div class="container">

    <div class="policy-header">
      <span class="policy-badge">🔄 Return Policy</span>

      <h1>Sangeetha Toys</h1>

      <p>
        We want every customer to have a happy shopping experience.
        If you receive a damaged, defective, or incorrect product,
        we're here to help with returns and exchanges.
      </p>
    </div>

    <div class="policy-content">

      <div class="policy-item">
        <h4>1. Return Eligibility</h4>

        <ul>
          <li>Products can be returned if they are damaged during transit.</li>
          <li>Products can be returned if an incorrect item was delivered.</li>
          <li>Products can be returned if they have a manufacturing defect.</li>
          <li>Return requests must be submitted within the specified return period.</li>
        </ul>

      </div>

      <div class="policy-item">
        <h4>2. Reporting a Return</h4>

        <ul>
          <li>Please report issues within 24–48 hours of receiving the product.</li>
          <li>Provide clear photos or videos showing the damage or issue.</li>
          <li>Our support team will review the request and guide you through the process.</li>
        </ul>

      </div>

      <div class="policy-item">
        <h4>3. Return Conditions</h4>

        <ul>
          <li>The product must be unused and in its original packaging.</li>
          <li>All accessories, manuals, and included items must be returned.</li>
          <li>Products showing signs of misuse or physical damage caused after delivery may not qualify for returns.</li>
        </ul>

      </div>

      <div class="policy-item">
        <h4>4. Non-Returnable Items</h4>

        <ul>
          <li>Gift cards and promotional items.</li>
          <li>Products purchased during final clearance sales.</li>
          <li>Items damaged due to improper handling after delivery.</li>
          <li>Opened consumable or personalized products, where applicable.</li>
        </ul>

      </div>

      <div class="policy-item">
        <h4>5. Refunds & Exchanges</h4>

        <ul>
          <li>Approved returns may be eligible for a replacement, exchange, or refund.</li>
          <li>Refunds will be processed through the original payment method.</li>
          <li>Processing times may vary depending on banks and payment providers.</li>
        </ul>

      </div>

      <div class="policy-item">
        <h4>6. Contact Support</h4>

        <ul>
          <li>If you need assistance with a return, please contact our customer support team.</li>
          <li>We are committed to resolving issues quickly and ensuring customer satisfaction.</li>
        </ul>

      </div>

    </div>

  </div>
</div>